/*!
 * HDT Petals — Animated Falling Petals System
 * BPRADO Theme
 * Reads config from window.hdtPetalsConfig (set by hdt-petals.liquid)
 */

(function () {
  'use strict';

  /* ---- helpers ---- */
  var rand = function (min, max) {
    return Math.random() * (max - min) + min;
  };

  var hexToRgb = function (hex) {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    var n = parseInt(hex, 16);
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  };

  /* Generates three tonal variants from a base hex color */
  var petalColors = function (hex, opacity) {
    var c = hexToRgb(hex);
    var light = 'rgba(' + Math.min(c.r + 30, 255) + ',' + Math.min(c.g + 20, 255) + ',' + Math.min(c.b + 20, 255) + ',' + Math.min(opacity + 0.10, 1) + ')';
    var mid   = 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + opacity + ')';
    var dark  = 'rgba(' + Math.max(c.r - 40, 0) + ',' + Math.max(c.g - 35, 0) + ',' + Math.max(c.b - 30, 0) + ',' + Math.max(opacity - 0.15, 0.20) + ')';
    var vein  = 'rgba(' + Math.max(c.r - 55, 0) + ',' + Math.max(c.g - 50, 0) + ',' + Math.max(c.b - 40, 0) + ',0.50)';
    return { light: light, mid: mid, dark: dark, vein: vein };
  };

  /* ---- build overlay ---- */
  function buildOverlay(cfg) {
    var overlay = document.getElementById('hdt-petals-overlay');
    if (!overlay) return;

    /*
     * speed is 1-10 from theme settings.
     * Map: speed=1 → very slow (factor 2.5×), speed=4 → normal (1×), speed=10 → fast (0.3×)
     */
    var spd = Math.max(cfg.speed || 4, 1);
    var speedFactor = 2.5 / (spd * 0.625);

    /* ---------------------------------------------------
     * MODE: 'document' vs 'fixed'
     *
     * fixed    → overlay is position:fixed, pétalas ficam sempre na tela.
     * document → overlay é position:absolute, cobre toda a altura do site.
     *            As pétalas ficam distribuídas pelo documento inteiro;
     *            novas aparecem conforme o usuário rola para baixo.
     * --------------------------------------------------- */
    var isDocumentMode = (cfg.mode === 'document');
    var pageHeight = 0;
    var vh = window.innerHeight || 800;

    if (isDocumentMode) {
      /* Lê a altura total da página ANTES de modificar o overlay */
      pageHeight = Math.max(
        document.documentElement.scrollHeight || 0,
        document.body ? document.body.scrollHeight : 0,
        vh * 2
      );

      overlay.classList.add('hdt-petals--document');
      overlay.style.setProperty('--overlay-height', pageHeight + 'px');
    }

    /* quantity split between the two models */
    var totalCount = Math.max(cfg.quantity || 18, 1);

    /* Em modo documento, escala a quantidade proporcional à altura da página
     * para que cada "tela" tenha a mesma densidade de pétalas. Máximo 5×. */
    if (isDocumentMode && pageHeight > 0) {
      var densityFactor = Math.min(Math.ceil(pageHeight / vh), 5);
      totalCount = Math.round(totalCount * densityFactor);
    }

    /* Camada z-index — injeta CSS antes de renderizar as pétalas */
    injectLayerCSS(cfg);

    /* Build groups */
    var groups = [];
    if (cfg.model1_enabled) groups.push({
      model:   cfg.model1_type    || 1,
      color:   cfg.model1_color   || '#e8a0b0',
      opacity: cfg.model1_opacity || 5,
      count:   Math.ceil(totalCount * (cfg.model2_enabled ? 0.5 : 1))
    });
    if (cfg.model2_enabled) groups.push({
      model:   cfg.model2_type    || 2,
      color:   cfg.model2_color   || '#c4a4d4',
      opacity: cfg.model2_opacity || 5,
      count:   Math.floor(totalCount * (cfg.model1_enabled ? 0.5 : 1))
    });

    if (groups.length === 0) return;

    var fragment = document.createDocumentFragment();

    groups.forEach(function (group) {
      /*
       * Opacidade: setting 1–10 → base 0.10–1.00
       * Cada pétala recebe um valor aleatório entre 65% e 100% do base,
       * para manter a variação orgânica mesmo com opacidade alta.
       */
      var opacityBase = Math.min(Math.max((group.opacity || 5) / 10, 0.10), 1.0);
      var colors      = petalColors(group.color, opacityBase);
      var modelClass  = 'hdt-petal--m' + group.model;

      for (var i = 0; i < group.count; i++) {
        var el = document.createElement('span');
        el.className = 'hdt-petal ' + modelClass;

        var w   = rand(14, 26).toFixed(1);
        var h   = parseFloat(w) * rand(1.4, 1.8);
        var dur = rand(6.5, 14.0) * speedFactor;

        /* Opacidade por pétala: variação de ±35% em torno do base */
        var oMin = +(opacityBase * 0.65).toFixed(2);
        var oMax = +opacityBase.toFixed(2);

        el.style.setProperty('--x',          rand(0, 100).toFixed(2) + 'vw');
        el.style.setProperty('--w',          w + 'px');
        el.style.setProperty('--h',          h.toFixed(1) + 'px');
        el.style.setProperty('--dur',        dur.toFixed(2) + 's');
        el.style.setProperty('--delay',      '-' + rand(0, dur * 0.9).toFixed(2) + 's');
        el.style.setProperty('--sway-dur',   rand(2.2, 4.5).toFixed(2) + 's');
        el.style.setProperty('--sway-delay', '-' + rand(0, 4).toFixed(2) + 's');
        el.style.setProperty('--sway',       rand(-22, 22).toFixed(1) + 'px');
        el.style.setProperty('--driftx',     rand(-160, 160).toFixed(1) + 'px');
        el.style.setProperty('--fall',       rand(110, 130).toFixed(1) + 'vh');
        el.style.setProperty('--spin',       rand(140, 340).toFixed(1) + 'deg');
        el.style.setProperty('--r0',         rand(-28, 28).toFixed(1) + 'deg');
        el.style.setProperty('--shape-tilt', rand(-8, 8).toFixed(1) + 'deg');
        el.style.setProperty('--o',          rand(oMin, oMax).toFixed(2));
        el.style.setProperty('--petal-color-light', colors.light);
        el.style.setProperty('--petal-color-mid',   colors.mid);
        el.style.setProperty('--petal-color-dark',  colors.dark);
        el.style.setProperty('--petal-vein',         colors.vein);

        /* Em modo documento: distribui as pétalas por toda a altura do site.
         * Cada pétala tem uma posição Y fixa no documento — quando você rola
         * até ela, ela aparece caindo naquele ponto da página. */
        if (isDocumentMode && pageHeight > 0) {
          /* Distribui uniformemente de 0 até pageHeight (- 1 viewport para não
           * criar pétalas que só vivem abaixo da dobra do site) */
          var startY = rand(0, Math.max(pageHeight - vh * 0.6, vh));
          el.style.top = startY.toFixed(0) + 'px';
        }

        fragment.appendChild(el);
      }
    });

    overlay.appendChild(fragment);
  }

  /* ---- re-init helper (para resize em modo documento) ---- */
  function clearAndRebuild(cfg) {
    var overlay = document.getElementById('hdt-petals-overlay');
    if (!overlay) return;
    overlay.innerHTML = '';
    overlay.className = '';
    buildOverlay(cfg);
  }

  /* -------------------------------------------------------
   * Controle de camada (z-index)
   *
   * O overlay fica em z-index 9990 (definido no CSS).
   * Para elementos que devem aparecer NA FRENTE das pétalas,
   * injetamos CSS com z-index 9991 + position: relative.
   * Para elementos que devem ficar ATRÁS das pétalas,
   * não fazemos nada (eles ficam em seu z-index natural,
   * abaixo do overlay 9990).
   *
   * Seletores cobrem Ecomus + estrutura genérica Shopify.
   * ------------------------------------------------------- */
  function injectLayerCSS(cfg) {
    var existing = document.getElementById('hdt-petals-layer-css');
    if (existing) existing.remove();

    var ABOVE_Z = 9991; /* acima do overlay (9990) */
    var raise   = [];   /* seletores que devem ficar NA FRENTE das pétalas */

    /* --- Produtos --- */
    if (!cfg.over_products) {
      /* Ecomus-specific + Shopify genérico */
      raise = raise.concat([
        '.card-wrapper',
        '.card-product',
        '.hdt-pr-item',
        '.hdt-product-item',
        '.product-card',
        '.product-item',
        '.collection-product-card',
        '[data-product-card]',
        '.grid__item > .card',
        '.product-grid .card'
      ]);
    }

    /* --- Cabeçalho / menu --- */
    if (!cfg.over_header) {
      raise = raise.concat([
        'header.header',
        '.site-header',
        '#shopify-section-header',
        '.sticky-header',
        '#header'
      ]);
    }

    /* --- Banners / slideshow ---
     * Se over_banners = false, banners devem ficar NA FRENTE das pétalas. */
    if (!cfg.over_banners) {
      raise = raise.concat([
        '.banner',
        '.slideshow',
        '.hero',
        '.hero-banner',
        '.hdt-banner',
        '.section-image-banner',
        '.media-with-text',
        '[data-section-type="slideshow"]',
        '[data-section-type="image-banner"]'
      ]);
    }

    if (raise.length === 0) return; /* tudo sobre tudo — sem CSS extra */

    var css = raise.join(', ') + ' {\n'
            + '  position: relative;\n'
            + '  z-index: ' + ABOVE_Z + ';\n'
            + '}\n';

    var styleEl       = document.createElement('style');
    styleEl.id        = 'hdt-petals-layer-css';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  /* ---- init ---- */
  function init() {
    var cfg = window.hdtPetalsConfig;
    if (!cfg || !cfg.enabled) return;

    buildOverlay(cfg);

    /* Em modo documento, recalcula se a janela for redimensionada
     * (ex: rotação do celular, painéis que abrem/fecham) */
    if (cfg.mode === 'document') {
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          clearAndRebuild(cfg);
        }, 400);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
